import { createSelector } from 'reselect';
import { getSortString } from 'domain/utils';
import { communicationStatus } from 'services/utils';
import settingsSelectors from 'store/settings/selectors';
import tagSelectors from 'store/tag-management/selectors';

const getData = (state) => state.cache.lineAddFriendSetting.data.list.data;
const getMetadata = (state) =>
  state.cache.lineAddFriendSetting.data.list.metadata;
const getSettings = (state) => state.cache.lineAddFriendSetting.settings;
const getStatusList = (state) => state.cache.lineAddFriendSetting.status.list;

const getSort = (state) => state.cache.lineAddFriendSetting.settings.sort;

const getStatusSetting = (state) =>
  state.cache.lineAddFriendSetting.status.setting;
const getDetailSetting = (state) =>
  state.cache.lineAddFriendSetting.data.setting.item;

const getSortRequest = createSelector([getSort], (sort) => {
  return getSortString(sort);
});

const getStatesForList = createSelector(
  [
    getData,
    getMetadata,
    getSettings,
    settingsSelectors.getLoadingByStatus([getStatusList]),
  ],
  (data, metadata, settings, isLoading) => ({
    isLoading,
    data,
    metadata,
    settings,
  })
);

const getStatesForSetting = createSelector(
  [
    getStatusSetting,
    getDetailSetting,
    settingsSelectors.getLoadingByStatus([tagSelectors.getStatusList]),
    tagSelectors.getList,
  ],

  (statusSetting, detailSetting, statusTagList, tagListData) => ({
    isLoadingSetting: statusSetting === communicationStatus.LOADING,
    detailSetting,
    statusTagList,
    tagListData,
  })
);

const lineAddFriendSettingSelector = {
  getStatesForList,
  getSortRequest,
  getStatesForSetting,
  getMetadata,
};

export default lineAddFriendSettingSelector;
